<template>
  <main role="main">
    <section class="section htp-section pb-0">
      <div class="container">
        <h1 class="htp-title">{{ $t('Home.HowToParticipateTitle') }}</h1>
        <div class="row justify-content-center">
          <div class="col-md-3 col-4 htp-card">
            <img :src="$t('Home.ShopImg')" alt="Shop" />
            <h4 v-html="$t('Home.ShopTitle')"></h4>
            <p v-html="$t('Home.ShopDetail')"></p>
          </div>
          <div class="col-md-3 col-4 htp-card">
            <img :src="$t('Home.SnapImg')" alt="Snap" />
            <h4 v-html="$t('Home.SnapTitle')"></h4>
            <p v-html="$t('Home.SnapDetail')"></p>
          </div>
          <div class="col-md-3 col-4 htp-card">
            <img :src="$t('Home.SendImg')" alt="Send" />
            <h4 v-html="$t('Home.SendTitle')"></h4>
            <p v-html="$t('Home.SendDetail')"></p>
          </div>
        </div>
      </div>
    </section>

    <section class="section ready-section">
      <div class="container">
        <h2 class="mb-3" v-html="$t('Home.ReadytoSubmitTitle')"></h2>
        <p class="page-subheader mb-4 mx-auto" style="max-width: 720px" v-html="$t('Home.ReadytoSubmitDesc')"></p>

        <div class="mb-4">
          <router-link to="/Upload" class="btn-dark-pill">
            {{ $t('Home.GetStartedBtn') }}
          </router-link>
        </div>

        <p class="small-links mb-2"><small v-html="$t('Home.ParticipatingProductLink')"></small></p>
        <p class="small-links mb-0">
          <small v-html="$t('Home.HavingTroubleLink')"></small><br />
          <small>
            <router-link to="/Support?havingTrouble">{{ $t('Home.CheckFAQ') }}</router-link>
          </small>
        </p>
      </div>
    </section>
  </main>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.htp-section {
  background: var(--brand-maroon);
}
</style>
